import { Map, fromJS, List } from "immutable";
import { messageTypes } from "~/components/Chat/Hub/ConversationContent/Message/SystemMessage/types";
import {
  FETCH_CONVERSATION_MESSAGES_SUCCESS,
  FETCH_CONVERSATION_MESSAGE_SUCCESS,
  ADD_CONVERSATION_MESSAGE_LOADING,
  ADD_CONVERSATION_MESSAGE_SUCCESS,
  ADD_CONVERSATION_MESSAGE_FROM_EVENT_STREAM,
  FETCH_CONVERSATIONS_SUCCESS,
  FETCH_CONVERSATION_SUCCESS,
  DELETE_CONVERSATION_MESSAGE_FROM_EVENT_STREAM_SUCCESS,
  DELETE_CONVERSATION_MESSAGE_SUCCESS,
  DELETE_CONVERSATION_MESSAGE_LOADING,
  DELETE_CONVERSATION_MESSAGE_ERROR,
  ADD_CONVERSATION_MESSAGE_ERROR,
  EDIT_CONVERSATION_MESSAGE_LOADING,
  EDIT_CONVERSATION_MESSAGE_SUCCESS,
  EDIT_CONVERSATION_MESSAGE_ERROR,
  EDIT_CONVERSATION_MESSAGE_FROM_EVENT_STREAM,
  EDIT_CONVERSATION_FROM_EVENT_STREAM,
  INVITE_USER_CONVERSATION_SUCCESS,
  EDIT_CONVERSATION_SUCCESS,
  REMOVE_CONVERSATION_PARTICIPANT_SUCCESS,
  ADD_REACTION_LOADING,
  ADD_REACTION_SUCCESS,
  ADD_REACTION_ERROR,
  REMOVE_REACTION_LOADING,
  REMOVE_REACTION_SUCCESS,
  REMOVE_REACTION_ERROR,
  ADD_REACTION_FROM_EVENT_STREAM_SUCCESS,
  REMOVE_REACTION_FROM_EVENT_STREAM_SUCCESS,
} from "~/store/action_types";

const conversation_message = (state = Map(), action) => {
  switch (action.type) {
    case EDIT_CONVERSATION_MESSAGE_FROM_EVENT_STREAM:
    case ADD_CONVERSATION_MESSAGE_FROM_EVENT_STREAM:
    case FETCH_CONVERSATION_MESSAGE_SUCCESS:
    case ADD_CONVERSATION_MESSAGE_SUCCESS: {
      const { response = {} } = action;
      const { entities = {}, result = {} } = response;
      const { single: id } = result;
      const { conversation_messages = {} } = entities;

      const values = conversation_messages[id];

      if (values) {
        return fromJS(values);
      }

      return state;
    }
    case EDIT_CONVERSATION_MESSAGE_SUCCESS: {
      const { response = {} } = action;
      const { entities = {}, result = {} } = response;
      const { single: id } = result;
      const { conversation_messages = {} } = entities;

      const values = conversation_messages[id];

      if (values) {
        return fromJS({ ...values, loading: false, error: false });
      }

      return state;
    }
    case EDIT_CONVERSATION_MESSAGE_LOADING:
    case ADD_CONVERSATION_MESSAGE_LOADING: {
      const { attributes = {}, id } = action;
      const { body, ...rest } = attributes;
      return state.merge(fromJS({ ...rest, body, body_formatted: body, id, loading: true }));
    }
    case DELETE_CONVERSATION_MESSAGE_LOADING: {
      return state.merge(Map({ loading: true }));
    }
    case EDIT_CONVERSATION_MESSAGE_ERROR:
    case ADD_CONVERSATION_MESSAGE_ERROR: {
      return state.merge(Map({ loading: false, error: true }));
    }
    case DELETE_CONVERSATION_MESSAGE_ERROR: {
      return state.merge(Map({ loading: false }));
    }
    case REMOVE_REACTION_FROM_EVENT_STREAM_SUCCESS: {
      const { response = {} } = action;
      const { result: id } = response;
      if (id) {
        return Map({
          ...state.toObject(),
          reactions: state.get("reactions", List([])).filter((reactionId) => reactionId !== id),
        });
      }
      return state;
    }
    case ADD_REACTION_FROM_EVENT_STREAM_SUCCESS: {
      const { response = {} } = action;
      const { result: id } = response;
      if (id) {
        let reactions = state.get("reactions", List([]));

        if (reactions.indexOf(id) > -1) {
          return state;
        }

        reactions = reactions.push(id);

        return Map({ ...state.toObject(), reactions });
      }
      return state;
    }
    case ADD_REACTION_ERROR: {
      return Map({
        ...state.toObject(),
        reactions: state.get("reactions", List([])).filter((reaction) => reaction !== action.id),
      });
    }
    case ADD_REACTION_SUCCESS: {
      const { response = {} } = action;
      const { result = {} } = response;
      const { single: id } = result;
      if (id) {
        let reactions = state.get("reactions", List([]));
        reactions = reactions.filter((reaction) => reaction !== action.id);

        if (reactions.indexOf(id) < 0) {
          reactions = reactions.push(id);
        }

        return Map({ ...state.toObject(), reactions });
      }
      return state;
    }
    case REMOVE_REACTION_LOADING:
    case REMOVE_REACTION_SUCCESS: {
      if (action.reactionId) {
        let index = state.get("reactions", List([])).findIndex((reaction) => reaction === action.reactionId);
        let reactions = state.get("reactions", List([])).delete(`${index}`);

        return Map({ ...state.toObject(), reactions });
      }
      return state;
    }
    case REMOVE_REACTION_ERROR: {
      let reactions = state.get("reactions", List([])).push(action.reactionId);
      return Map({ ...state.toObject(), reactions });
    }
    case ADD_REACTION_LOADING: {
      let reactions = state.get("reactions", List([])).push(action.id);
      return Map({ ...state.toObject(), reactions });
    }
    default:
      return state;
  }
};

const conversation_messages = (state = Map(), action) => {
  switch (action.type) {
    case INVITE_USER_CONVERSATION_SUCCESS:
    case REMOVE_CONVERSATION_PARTICIPANT_SUCCESS:
    case EDIT_CONVERSATION_SUCCESS:
    case FETCH_CONVERSATION_MESSAGES_SUCCESS:
    case FETCH_CONVERSATION_SUCCESS:
    case EDIT_CONVERSATION_FROM_EVENT_STREAM:
    case FETCH_CONVERSATIONS_SUCCESS: {
      const { response = {} } = action;
      const { entities = {} } = response;
      const { conversation_messages = {} } = entities;
      return state.merge(fromJS(conversation_messages));
    }
    case EDIT_CONVERSATION_MESSAGE_FROM_EVENT_STREAM:
    case ADD_CONVERSATION_MESSAGE_FROM_EVENT_STREAM:
    case FETCH_CONVERSATION_MESSAGE_SUCCESS:
    case ADD_CONVERSATION_MESSAGE_SUCCESS: {
      const { response = {}, id } = action;
      const { result = {} } = response;
      const { single: messageId } = result;

      state = state.delete(`${id}`);

      if (messageId) {
        return state.set(`${messageId}`, conversation_message(state.get(`${messageId}`), action));
      }
      return state;
    }
    case EDIT_CONVERSATION_MESSAGE_SUCCESS: {
      const { response = {} } = action;
      const { result = {} } = response;
      const { single: messageId } = result;

      if (messageId) {
        return state.set(`${messageId}`, conversation_message(state.get(`${messageId}`), action));
      }

      return state;
    }
    case EDIT_CONVERSATION_MESSAGE_LOADING:
    case EDIT_CONVERSATION_MESSAGE_ERROR:
    case ADD_CONVERSATION_MESSAGE_ERROR:
    case DELETE_CONVERSATION_MESSAGE_ERROR:
    case DELETE_CONVERSATION_MESSAGE_LOADING:
    case ADD_CONVERSATION_MESSAGE_LOADING: {
      const { id } = action;
      if (id) {
        return state.set(`${id}`, conversation_message(state.get(`${id}`), action));
      }
      return state;
    }
    case DELETE_CONVERSATION_MESSAGE_FROM_EVENT_STREAM_SUCCESS:
    case DELETE_CONVERSATION_MESSAGE_SUCCESS: {
      const { id = 0 } = action;

      if (id > 0) {
        return state.delete(`${id}`);
      }

      return state;
    }
    case REMOVE_REACTION_FROM_EVENT_STREAM_SUCCESS:
    case ADD_REACTION_FROM_EVENT_STREAM_SUCCESS:
    case ADD_REACTION_LOADING:
    case ADD_REACTION_SUCCESS:
    case ADD_REACTION_ERROR:
    case REMOVE_REACTION_LOADING:
    case REMOVE_REACTION_ERROR:
    case REMOVE_REACTION_SUCCESS: {
      const { parentId, parentType } = action;

      const isConversationMessageParent =
        parentType === "ConversationMessage" ||
        messageTypes[parentType] === "UserMessage" ||
        parentType === "UserMessage";

      if (parentId && isConversationMessageParent) {
        return state.set(`${parentId}`, conversation_message(state.get(`${parentId}`), action));
      }

      return state;
    }
    default:
      return state;
  }
};

export default conversation_messages;
